export class AdminPasscode {
    constructor( 
        public AdminPasscodeID?: string,
        public AdminPasscode?: string,
        public ClinicID?: string,
        public UpdatedBy?: string,
        public UpdatedOn?: Date,
    ) {}
}